import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroductoryCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="introductory-call-to-action" ref={ref} className="relative w-full py-20 lg:py-32 overflow-hidden bg-background">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className={`flex flex-col gap-8 max-w-2xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium w-fit">
                <Sparkles className="w-4 h-4" />
                <span>Next-Gen Intelligence</span>
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-display font-bold text-foreground leading-tight">
                Transform Your Vision with <span className="text-primary">StrategyAI Partners</span>
              </h2>
              
              <p className="text-lg text-muted-foreground leading-relaxed">To request an executive consultation, please complete the form below. This is intended for leadership teams seeking structured AI strategy, governance, and oversight support.</p>
            </div>

            <div className="flex flex-wrap gap-4">
              <Link to="/ContactPage">
                <Button className="btn-primary group px-7 py-3 h-auto rounded-sm">
                  Start Your Journey
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              <Link to="/ServicesPage">
                <Button variant="outline" className="px-7 py-3 h-auto rounded-sm border-primary/20 hover:bg-primary/10 text-foreground transition-colors">
                  Explore Services
                </Button>
              </Link>
            </div>

            {}
            <div className="pt-4 border-t border-primary/10">
              <p className="text-sm text-muted-foreground mb-3 font-medium">Trusted by industry leaders in</p>
              <div className="flex gap-6 opacity-60 grayscale hover:grayscale-0 transition-all duration-300">
                {}
                <span className="font-display font-bold text-lg text-primary/40">FinTech</span>
                <span className="font-display font-bold text-lg text-primary/40">HealthCare</span>
                <span className="font-display font-bold text-lg text-primary/40">Logistics</span>
              </div>
            </div>
          </div>

          {}
          <div className={`relative transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-strong border border-white/20 bg-white/5 backdrop-blur-sm group">
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent mix-blend-overlay z-10 pointer-events-none" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541635/img/abstract_ai_network_visualization.png" alt="Abstract visualization of AI neural networks and data processing" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 p-4 rounded-xl glass-effect z-20 animate-fade-in-up animate-delay-200">
                <div className="flex items-center gap-4">
                  <div className="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center text-primary">
                    <Sparkles className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground">AI Optimization</p>
                    <p className="text-xs text-muted-foreground">Efficiency increased by 40%</p>
                  </div>
                </div>
              </div>
            </div>

            {}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-primary/10 via-secondary/5 to-accent/10 rounded-full blur-3xl opacity-40" />
          </div>
        </div>
      </div>
    </section>;
}